export default __webpack_public_path__ + "static/media/TestScriptor.ce653973.png";